import React from 'react'
import { CircularProgress, Typography, Box } from '@mui/material'
import { useGetFormTemplateQuery } from '@/core/services/form'
import ViewFormTemplate from '../components/ViewFormTemplate'

interface ViewFormTemplateContainerProps {
  templateId: string
}

const ViewFormTemplateContainer: React.FC<ViewFormTemplateContainerProps> = ({ templateId }) => {
  const { data: template, isLoading, error } = useGetFormTemplateQuery(templateId)

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Typography color="error" sx={{ p: 3 }}>
        Error loading template
      </Typography>
    )
  }

  if (!template) {
    return (
      <Typography color="text.secondary" sx={{ p: 3 }}>
        Template not found
      </Typography>
    )
  }

  return <ViewFormTemplate template={template} />
}

export default ViewFormTemplateContainer
